import React, { useEffect, useState, useCallback } from "react";
import Footer from "./Footer";
import Security from "./Security";
import Downloadapp from "./Downloadapp";
import { Link, useNavigate } from "react-router-dom";
import Shearchbar from "./Shearchbar";
import Navbar from "./Navbar";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Manubar from "./Manubar";
import "./loader.css";

const Checkout = () => {
  const navigate = useNavigate();

  // State declarations
  const [showprofile, setshowprofile] = useState({});
  const [show_address, setshow_address] = useState([]);
  const [address_index, setaddress_index] = useState(0);
  const [show_cart_list, setshow_cart_list] = useState([]);
  const [totolprice, settotalprice] = useState(0);
  const [showdelivery, setshowdelivery] = useState(0);
  const [adressstatus, setadressstatus] = useState("");
  const [orderstatus, setorderstatus] = useState(true);
  const [loading, setLoading] = useState(false);
  const [cartId , setCartId] = useState('');

  const _id = secureLocalStorage.getItem("n_id");
  const token = secureLocalStorage.getItem("n_token");
  const cart_list_id = secureLocalStorage.getItem("n_cartlist_id");
  const offerprice = secureLocalStorage.getItem("n_oofferprice_chackout");
  // let deleveryCharges = secureLocalStorage.getItem("deliveryCharges");
  // console.log("deleveryCharges",deleveryCharges)
  //   console.log("showdelivery",showdelivery)

  // Calculate totals
  const allprice = totolprice + showdelivery;
  const offer_price = allprice >= (offerprice || 0) ? offerprice || 0 : 0;
  const alltotal = totolprice + showdelivery - offer_price;

  // Address form state
  const [add_address, setadd_address] = useState({
    user_id: _id,
    landmark: "",
    address: "",
    city: "",
    pin_code: "",
  });

  // Get user profile
  useEffect(() => {
    const fetchUserProfile = async () => {
      if (!_id || !token) return;

      try {
        const items = { user_id: _id };
        const res = await axios.post(
          `${process.env.REACT_APP_API}website/get_user_profile`,
          items,
          { headers: { token: token } }
        );

        if (res.data.result) {
          setshowprofile(res.data.data);
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

    fetchUserProfile();
  }, [_id, token]);

  // Get user addresses
  useEffect(() => {
    const fetchUserAddresses = async () => {
      if (!_id || !token) return;

      try {
        const items = { user_id: _id };
        const res = await axios.post(
          `${process.env.REACT_APP_API}website/get_address`,
          items,
          { headers: { token: token } }
        );

        if (res.data.result) {
          setshow_address(res.data.data);
          
        }
      } catch (error) {
        console.error("Error fetching addresses:", error);
      }
    };

    fetchUserAddresses();
  }, [_id, token]);

  // Get delivery charge
  useEffect(() => {
    const fetchDeliveryCharge = async () => {
      if (!token) return;

      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}website/delivery_charge_list`,
          { headers: { token: token } }
        );

        if (res?.data?.data?.delivery_charge) {
          setshowdelivery(res.data.data.delivery_charge);
        }
      } catch (error) {
        console.error("Error fetching delivery charge:", error);
      }
    };

    fetchDeliveryCharge();
  }, [token]);

  // Get cart details
  useEffect(() => {
    const fetchCartDetails = async () => {
      if (!_id || !token) {
        navigate("/");
        return;
      }

      try {
        const items = {
          user_id: _id,
        };

        const res = await axios.post(
          `${process.env.REACT_APP_API}website/cart_details`,
          items,
          { headers: { token: token } }
        );

        if (res.data.result) {
          setshow_cart_list(res.data.data);
          setCartId(res.data.cart_id);
          
          // Calculate total price
          const sum = res.data.data.reduce(
            (acc, item) => acc + (item?.total_price_ammount || 0),
            0
          );
          settotalprice(sum);
        }
      } catch (error) {
        console.error("Error fetching cart details:", error);
        toast.error("Failed to load cart items");
      }
    };

    fetchCartDetails();
  }, [_id, token, navigate]);

  // Use address handler
  const useaddress = (items, index) => {
    setaddress_index(index);
    toast.success("Address selected successfully");
  };

  // Input handler for address form
  const inpuHandel = (event) => {
    setadd_address({
      ...add_address,
      [event.target.name]: event.target.value,
    });
  };

  // Form submit handler
  const FormHandel = async (e) => {
    e.preventDefault();

    if (
      !add_address.landmark ||
      !add_address.address ||
      !add_address.city ||
      !add_address.pin_code
    ) {
      toast.error("Please fill all address fields");
      return;
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API}website/add_address`,
        add_address,
        { headers: { token: token } }
      );

      if (res.data.result) {
        toast.success(res.data.msg);
        setadd_address({
          user_id: _id,
          landmark: "",
          address: "",
          city: "",
          pin_code: "",
        });

        // Refresh addresses list
        const addressRes = await axios.post(
          `${process.env.REACT_APP_API}website/get_address`,
          { user_id: _id },
          { headers: { token: token } }
        );

        if (addressRes.data.result) {
          setshow_address(addressRes.data.data);
        }
      }
    } catch (error) {
      console.error("Error adding address:", error);
      toast.error("Failed to add address");
    }
  };

  // Place order handler
  const pleceorder = async () => {
    if (!_id || !token) {
      toast.error("Please login to continue");
      return;
    }

    if (show_address.length === 0 || !show_address[address_index]) {
      setadressstatus("Please select or add a delivery address");
      toast.error("Please select a delivery address");
      return;
    }

    setorderstatus(false);
    setLoading(true);

    try {
      const selectedAddress = show_address[address_index];

      if (!selectedAddress.landmark) {
        setadressstatus("Please select a valid address");
        setorderstatus(true);
        setLoading(false);
        return;
      }
      console.log(alltotal)

      const orderResponse = await axios.post(
        `${process.env.REACT_APP_API}website/create_razorpay_order`,
        {
          amount: alltotal, // alltotal
        }
      );

      const { id: orderId } = orderResponse.data;

      const options = {
        key: process.env.RAZORPAY_KEY_ID,
        amount: alltotal * 100, // alltotal * 100
        currency: "INR",
        name: "Vaishnavi Thekua",
        description: "Order",
        order_id: orderId,
        handler: async (response) => {
          console.log(response);
          
          try {
            const data = {
              user_id: _id,
              cart_id: cartId,
              address: selectedAddress.landmark,
              city: selectedAddress.city,
              pin_code: selectedAddress.pin_code,
              discount_price: offerprice ? offerprice : "0",
              grand_total: alltotal,
              delivery_charge: showdelivery,
              paymentId: response.razorpay_payment_id,
              payment_status: "success",
            };

            const res = await axios.post(
              `${process.env.REACT_APP_API}website/booking_order`,
              data,
              { headers: { token: token } }
            );

            if (res.data.result) {
              toast.success(res.data.msg);
              secureLocalStorage.removeItem("n_cartlist_id");
              secureLocalStorage.removeItem("n_oofferprice_chackout");

              setTimeout(() => {
                navigate(`/myaccount`, { state: "orders"});
              }, 2000);
            }
          } catch (error) {
            console.error("Error creating order:", error);
            toast.error("Failed to create order");
          }
        },
        modal: {
          ondismiss: function () {
            console.log("Payment popup closed by user.");
            toast.info("Payment cancelled by user");
            setorderstatus(true);
            setLoading(false);
            
          },
        },
        prefill: {
          name: selectedAddress.name || "",
          email: "customer@example.com",
          contact: selectedAddress.phone || "",
        },
        theme: {
          color: "#3399cc",
        },
      };

      const rzp1 = new window.Razorpay(options);
      rzp1.open();

      // const data = {
      //   "user_id": _id,
      //   "cart_id": cart_list_id,
      //   "address": selectedAddress.landmark,
      //   "city": selectedAddress.city,
      //   "pin_code": selectedAddress.pin_code,
      //   "discount_price": offerprice ? offerprice : "0",
      //   "grand_total": alltotal,
      //   "delivery_charge":showdelivery
      // };

      // const res = await axios.post(
      //   `${process.env.REACT_APP_API}website/booking_order`,
      //   data,
      //   { headers: { "token": token } }
      // );

      // if (res.data.result) {
      //   toast.success(res.data.msg);
      //   secureLocalStorage.removeItem("n_cartlist_id");
      //   secureLocalStorage.removeItem("n_oofferprice_chackout");

      //   setTimeout(() => {
      //     navigate(`/myaccount`);
      //   }, 2000);
      // }
    } catch (error) {
      console.error("Error placing order:", error);
      toast.error("Failed to place order");
      setorderstatus(true);
    } finally {
      setLoading(false);
    }
  };

  // Calculate item total
  const calculateItemTotal = (item) => {
    return (item.price * (item.no_of_product || 1)).toFixed(2);
  };

  return (
    <div>
      <ToastContainer position="top-center" />

      {/* Header Section */}
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <header>
        <Shearchbar />
        <Navbar />
      </header>

      {/* Breadcrumb Section */}
      <nav className="breadcrumb-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Checkout Page
                </li>
              </ol>
            </div>
          </div>
        </div>
      </nav>

      {/* Checkout Section */}
      <div className="check-out-section section-mb">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="billing-info-wrap">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h3 className="title">Billing Details</h3>
                  {show_address.length > 0 && (
                    <button
                      className="btn btn-success"
                      data-toggle="modal"
                      data-target="#myModal"
                    >
                      Change Address
                    </button>
                  )}
                </div>

                {/* User Details Card */}
                <div className="card mb-4">
                  <div className="card-header">
                    <h5 className="mb-0">User Details</h5>
                  </div>
                  <div className="card-body">
                    <div className="row mb-2">
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <strong>Full Name:</strong>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        {showprofile?.full_name || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <strong>Email:</strong>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        {showprofile?.email || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <strong>Mobile Number:</strong>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        {showprofile?.mobile_no || "N/A"}
                      </div>
                    </div>

                    {/* Selected Address Details */}
                    {show_address[address_index] && (
                      <>
                        <hr />
                        <div className="row mb-2">
                          <div className="col-lg-6 col-md-6 col-sm-12">
                            <strong>Location:</strong>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-12">
                            {show_address[address_index]?.landmark || "N/A"}
                          </div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-lg-6 col-md-6 col-sm-12">
                            <strong>Address:</strong>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-12">
                            {show_address[address_index]?.address || "N/A"}
                          </div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-lg-6 col-md-6 col-sm-12">
                            <strong>City:</strong>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-12">
                            {show_address[address_index]?.city || "N/A"}
                          </div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-lg-6 col-md-6 col-sm-12">
                            <strong>Pincode:</strong>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-12">
                            {show_address[address_index]?.pin_code || "N/A"}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                {/* Add New Address Form */}
                <div className="card">
                  <div className="card-header">
                    <h5 className="mb-0">Add New Delivery Address</h5>
                  </div>
                  <div className="card-body">
                    <form onSubmit={FormHandel}>
                      <div className="form-group">
                        <label>Location *</label>
                        <input
                          type="text"
                          value={add_address.landmark}
                          className="form-control"
                          required
                          name="landmark"
                          onChange={inpuHandel}
                          placeholder="Enter location/landmark"
                        />
                      </div>
                      <div className="form-group">
                        <label>Address *</label>
                        <input
                          type="text"
                          value={add_address.address}
                          className="form-control"
                          required
                          name="address"
                          onChange={inpuHandel}
                          placeholder="Enter complete address"
                        />
                      </div>
                      <div className="form-group">
                        <label>City *</label>
                        <input
                          type="text"
                          value={add_address.city}
                          className="form-control"
                          required
                          name="city"
                          onChange={inpuHandel}
                          placeholder="Enter city"
                        />
                      </div>
                      <div className="form-group">
                        <label>Pincode *</label>
                       <input
  type="text"
  value={add_address.pin_code}
  className="form-control"
  name="pin_code"
  onChange={inpuHandel}
  placeholder="Enter 6-digit pincode"
  maxLength={6}
/>
                      </div>
                      <div className="form-group mb-0">
                        <button
                          type="submit"
                          className="btn btn-success btn-block"
                        >
                          Add Address
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-5 mt-4 mt-lg-0">
              <div className="your-order-area">
                <h3 className="title text-center">Your Order</h3>
                <div className="your-order-wrap gray-bg-4">
                  <div className="your-order-product-info">
                    {/* Order Items Table */}
                    <div className="table-responsive">
                      <table className="table">
                        <thead className="thead-dark">
                          <tr>
                            <th>Product</th>
                            <th>Qty</th>
                            <th>Price</th>
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {show_cart_list.map((item, index) => (
                            <tr key={`${item.product_id}-${index}`}>
                              <td>{item.product_name}</td>
                              <td>{item.no_of_product}</td>
                              <td>₹{item.price}</td>
                              <td>₹{calculateItemTotal(item)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Order Summary */}
                    <div className="your-order-bottom mt-3">
                      <ul className="list-unstyled gap-2">
                        <li className="w-50 d-flex justify-content-between">
                          <span>Subtotal</span>
                          <span>₹{totolprice.toFixed(2)}</span>
                        </li>
                        <li className="w-50 d-flex justify-content-between">
                          <span>Shipping</span>
                          <span>
                            {showdelivery
                              ? `₹${showdelivery.toFixed(2)}`
                              : "Free"}
                          </span>
                        </li>
                        {offer_price > 0 && (
                          <li className="d-flex justify-content-between text-success">
                            <span>Discount</span>
                            <span>-₹{offer_price.toFixed(2)}</span>
                          </li>
                        )}
                      </ul>
                    </div>

                    <div className="your-order-total mt-3">
                      <ul className="list-unstyled">
                        <li className="w-100 d-flex justify-content-between">
                          <strong>Total</strong>
                          <strong>₹{alltotal.toFixed(2)}</strong>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Payment Methods */}
                  {/* <div className="payment-method mt-4">
                    <div className="payment-accordion element-mrg">
                      <div className="panel-group" id="accordion">
                        <div className="panel payment-accordion">
                          <div className="panel-heading" id="method-one">
                            <h4 className="panel-title">
                              <a
                                data-toggle="collapse"
                                data-parent="#accordion"
                                href="#method1"
                              >
                                Cash on Delivery
                              </a>
                            </h4>
                          </div>
                          <div
                            id="method1"
                            className="panel-collapse collapse show"
                          >
                            <div className="panel-body">
                              <p>Pay with cash when your order is delivered.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>

                {/* Place Order Button */}
                <div className="Place-order mt-4">
                  {adressstatus && (
                    <div className="alert alert-warning" role="alert">
                      {adressstatus}
                    </div>
                  )}

                  {orderstatus ? (
                    <button
                      className="btn btn-dark btn-lg w-100"
                      onClick={pleceorder}
                      disabled={show_cart_list.length === 0 || loading}
                    >
                      {loading ? "Processing..." : "Place Order"}
                    </button>
                  ) : (
                    <div className="text-center py-3">
                      <div className="loader"></div>
                      <p className="mt-2">Processing your order...</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Address Selection Modal */}
      <div className="modal fade" id="myModal">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Select Delivery Address</h4>
              <button type="button" className="close" data-dismiss="modal">
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                {show_address.map((items, index) => (
                  <div
                    className="col-lg-12 col-md-12 col-sm-12 mb-3"
                    key={items._id}
                  >
                    <div className="card">
                      <div className="card-body">
                        <p>
                          <strong>Location:</strong> {items.landmark}
                        </p>
                        <p>
                          <strong>Address:</strong> {items.address}
                        </p>
                        <p>
                          <strong>City:</strong> {items.city}
                        </p>
                        <p>
                          <strong>Pincode:</strong> {items.pin_code}
                        </p>
                      </div>
                      <div className="card-footer text-center">
                        <button
                          data-dismiss="modal"
                          className="btn btn-success"
                          onClick={() => useaddress(items, index)}
                        >
                          Use This Address
                        </button>
                      </div>
                    </div>
                  </div>
                ))}

                {show_address.length === 0 && (
                  <div className="col-12 text-center py-4">
                    <p>No addresses found. Please add a delivery address.</p>
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      
      <Security />
      <Footer />
    </div>
  );
};

export default Checkout;
